import React, { useEffect, useState } from 'react';
import { Layout, Menu, Image } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { HomeOutlined, FileSearchOutlined, UnorderedListOutlined, AuditOutlined, FilePdfOutlined, FileAddOutlined, BookOutlined } from '@ant-design/icons';
import brigadeLogo from '../../assets/images/brigade.png';
import { useInvContext } from '../../context/InvContext';
import { useAuth } from '../../context/AuthContext';
import '../../styles/common.css';
import axios from '../../util/axiosConfig';

const { Sider } = Layout;

const Sidebar: React.FC = () => {
  const { user } = useAuth();
  const { isAdmin, setIsAdmin } = useInvContext();
  const location = useLocation();
  const [userManualLink, setUserManualLink] = useState<string>('');

  const getSelectedKey = () => {
    const pathname = location.pathname;

    if (pathname.startsWith('/dashboard')) {
      return '1';
    } else if (pathname.startsWith('/invoice-list')) {
      return '2';
    } else if (pathname.startsWith('/user-list')) {
      return '3';
    } else if (pathname.startsWith('/role-list')) {
      return '4';
    } else if (pathname.startsWith('/tolerance')) {
      return '5';
    } else if (pathname.startsWith('/address-list')) {
      return '7';
    } else {
      return '1';
    }
  };

  const userManual = async () => {
    try {
      const response = await axios.get(`/user-manual/get`, {});
      if (response?.data) {
        const url = response.data?.data;
        setUserManualLink(url);
      }
    } catch (error) {
      console.error('Failed to fetch panel data');
    } 
  };

  useEffect(() => {
    userManual();
  }, []);

  useEffect(() => {
    if (user?.roles?.includes('Admin')) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  })
  const menuItems = [
    {
      key: '1',
      title: 'Dashboard',
      icon: <HomeOutlined className="side-icons" />,
      label: <Link className="menu-link" to="/dashboard">Dashboard</Link>,
    },
    {
      key: '2',
      title: 'Invoice List',
      icon: <FileSearchOutlined className="side-icons" />,
      label: <Link className="menu-link" to="/invoice-list">Reports</Link>,
    },
  ];

  if (isAdmin) {
    menuItems.push(
      {
        key: '3',
        title: 'User List',
        icon: <AuditOutlined className="side-icons" />,
        label: <Link className="menu-link" to="/user-list">User List</Link>,
      },
      {
        key: '4',
        title: 'Role List',
        icon: <UnorderedListOutlined className="side-icons" />,
        label: <Link className="menu-link" to="/role-list">Role List</Link>,
      },
      {
        key: '5',
        title: 'Tolerance',
        icon: <FileAddOutlined className="side-icons" />,
        label: <Link className="menu-link" to="/tolerance-list">Tolerance</Link>,
      },
      {
        key: '6',
        title: 'User Manual',
        icon: <FilePdfOutlined className="side-icons" />,
        label: <a className="menu-link" href={userManualLink} target="_blank" rel="noopener noreferrer" >User Manual</a>,
      }
    );

    menuItems.push(
      {
        key: '7',
        title: 'Address',
        icon: <BookOutlined className="side-icons" />,
        label: <Link className="menu-link" to="/address-list">Tolerance</Link>,
      },
    );
  }
  
  
  return (
    <Sider width={80} style={{ background: 'white' }}>
      <div className="mt-2 brigadeLogo" style={{ display: 'flex', justifyContent: 'center' }}>
        <Image src={brigadeLogo} hidden={true} width={60} height="auto" preview={false} />
      </div>
      {location.pathname !== '/vendor-edit/verify' && location.pathname !== '/invoice-view' && 
        <Menu
          mode="inline"
          selectedKeys={[getSelectedKey()]}
          style={{ height: '100%', borderRight: 0, marginTop: 30 }}
          items={menuItems}
        />
      }
    </Sider>
  );
};

export default Sidebar;
